import React from 'react';
import clsx from 'clsx';

import { ReactComponent as ConsignmentSvg } from 'assets/consignment.svg';

import { CONSIGNMENT_ICON_TEST_ID, CONSIGNMENT_ICON_VALUE_TEST_ID } from './ConsignmentIcon.test-ids';

import styles from './ConsignmentIcon.module.scss';

interface ConsignmentIconProps {
  size: number;
  className?: string;
}

const ConsignmentIcon: React.FC<ConsignmentIconProps> = ({ size, className, ...props }) => {
  return (
    <div className={clsx(styles.consignmentIcon, className)} data-testid={CONSIGNMENT_ICON_TEST_ID} {...props}>
      <span
        className={clsx(styles.number, size > 99 && styles.biggerNumber)}
        data-testid={CONSIGNMENT_ICON_VALUE_TEST_ID}
      >
        {size}
      </span>
      <ConsignmentSvg aria-hidden='true' />
    </div>
  );
};

export default ConsignmentIcon;
